export default __webpack_public_path__ + "static/blog-img-16a1d9759735ebd0e2a53d57ebfbbfde.png";